export const PRODUCTION_COLLECTION_SIZE = 4_444;
export const PRODUCTION_RANK_MULTIPLIER = 2_803;
export const PRODUCTION_RANK_OFFSET = 619;

export const PRODUCTION_ALLOCATION = Object.freeze({
  grounded: 3_111,
  wall_street: 889,
  strange: 355,
  grail: 89,
});

export function productionRankForToken(tokenId) {
  const id = Number(tokenId);
  if (
    !Number.isInteger(id) ||
    id < 1 ||
    id > PRODUCTION_COLLECTION_SIZE
  ) {
    throw new RangeError(
      `Token ID must be between 1 and ${PRODUCTION_COLLECTION_SIZE}`,
    );
  }
  return (
    (Math.imul(id - 1, PRODUCTION_RANK_MULTIPLIER) +
      PRODUCTION_RANK_OFFSET) %
    PRODUCTION_COLLECTION_SIZE
  );
}

export function productionTierForToken(tokenId) {
  const rank = productionRankForToken(tokenId);
  if (rank < PRODUCTION_ALLOCATION.grounded) return "grounded";
  if (
    rank <
    PRODUCTION_ALLOCATION.grounded + PRODUCTION_ALLOCATION.wall_street
  ) {
    return "wall_street";
  }
  if (
    rank <
    PRODUCTION_ALLOCATION.grounded +
      PRODUCTION_ALLOCATION.wall_street +
      PRODUCTION_ALLOCATION.strange
  ) {
    return "strange";
  }
  return "grail";
}

export function productionTierLabel(tokenId) {
  return {
    grounded: "Internet Broker",
    wall_street: "Finance Villain",
    strange: "Strange Desk",
    grail: "1/1 Grail Scene",
  }[productionTierForToken(tokenId)];
}
